import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/airitemtype/`;

const getAirItemTypeList = async () => {
    return await axios.get(API_URL + 'list');
};

/** Get all air item types with rules (for admin / grouping) */
const getAirItemTypes = async () => {
    return await axios.get(API_URL);
};

const AirItemTypeService = {
  getAirItemTypeList,
  getAirItemTypes,
};
export default AirItemTypeService;
